/**
* https://www.ecma-international.org/ecma-262/11.0/index.html#sec-arraycreate
*/
export function ArrayCreate(len) {
	return Array.from({ length: len });
}
